import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { clearCampaign, getCampaign } from '../../../../modules/actions/campaigns'
import { campaignWasLoadedSelector } from '../../../../modules/selectors/campaigns'
import { adSelector, adsSelector, adWasLoadedSelector } from '../../../../modules/selectors/ads'

import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'

export const useLoadCampaignOnAdApprovalsPage = ({ isAdApprovalsPage, isFormOpen }) => {
  const dispatch = useDispatch()
  const campaignWasLoaded = useSelector(campaignWasLoadedSelector)
  const ads = useSelector(adsSelector)
  const ad = useSelector(adSelector)
  const adWasLoaded = useSelector(adWasLoadedSelector)

  useEffect(() => {
    // On ad approvals page we need to fetch campaign to have access to campaign objective
    if (isAdApprovalsPage && isFormOpen && adWasLoaded && !campaignWasLoaded) {
      const internalAd = ads.find(item => item.id === ad.id)
      const campaignId = internalAd?.campaign_id
      const adAccountId = internalAd?.ad_account_id

      dispatch(
        getCampaign(
          {
            id: campaignId,
            account: adAccountId
          },
          FACEBOOK_PLATFORM
        )
      )
    }
  }, [dispatch, isAdApprovalsPage, isFormOpen, ad, ads, adWasLoaded, campaignWasLoaded])

  useEffect(() => {
    if (isAdApprovalsPage && campaignWasLoaded && !isFormOpen) {
      dispatch(clearCampaign())
    }
  }, [dispatch, isAdApprovalsPage, campaignWasLoaded, isFormOpen])
}
